define('modules/Product/ProductDocumentsTab',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var viewModel = [];

    function load() {
        Roc.Logger.log('ProductDocuments viewmodel', viewModel);
        $('#productDocumentsTabWrapper').html(Roc.UI.templateV2('#productDocumentsTab-Tmp', viewModel));
    }

    function init(option) {
        if (option.model !== null) {
            viewModel.documents = option.model.documents || [];
            viewModel.flyers = option.model.flyers || [];
            viewModel.specificationSheets = option.model.specificationSheets || [];
            viewModel.catalog = option.model.catalog || [];
            viewModel.path = option.path;
            viewModel.empty = viewModel.documents.length === 0 &&
                viewModel.flyers.length === 0 &&
                viewModel.specificationSheets.length === 0 &&
                viewModel.catalog.length === 0;

            $.each(viewModel.documents, function(index, document) {
                fillExtensions(document.asset);
            });

            $.each(viewModel.flyers, function (index, document) {
                fillExtensions(document);
            });

            $.each(viewModel.specificationSheets, function (index, document) {
                fillExtensions(document);
            });

            $.each(viewModel.catalog, function (index, document) {
                fillExtensions(document);
            });
            load();
        }
    }

    function fillExtensions(document) {
        if (document.path) {
            document.extension = getExtensionFromPath(document.path);
        }
    }

    function getExtensionFromPath(path) {
        return path.split('.').pop();
    }

    var ProductDocuments = {
        init: init
    }

    Roc.Logger.debug('ProductDocumentsTab.js Loaded:', ProductDocuments);

    return ProductDocuments;
});
